import * as React from 'react';
import { Link, LinkProps, To } from 'react-router-dom';
import classNames from 'classnames';
import { ICbButtonProps } from 'Views/Components/Button/Button';

export interface LinkAsButtonProps
	extends
		Pick<ICbButtonProps, 'icon' | 'quickTypes' | 'display' | 'colors' | 'sizes' | 'widths' | 'className'>,
		Pick<LinkProps, 'target'> {
	to: To;
	replace?: boolean;
	children: React.ReactNode;
	// The click event is forwarded so callers can intercept navigation (preventDefault).
	onClick?: (event?: React.MouseEvent<HTMLAnchorElement>) => void;
	newStyle?: boolean;
	'data-test-id'?: string;
}

export default function LinkAsButton(props: LinkAsButtonProps) {
	const {
		to,
		replace,
		children,
		icon: iconProp,
		quickTypes: quickTypesProp,
		display: displayProp,
		colors: colorsProp,
		sizes: sizesProp,
		widths: widthsProp,
		className: classNameProp,
		onClick,
		target,
		newStyle,
		'data-test-id': dataTestId,
	} = props;

	const icon = iconProp ? `btn--icon icon-${iconProp.icon} ${iconProp.iconPos}` : '';
	const quickTypes = quickTypesProp ?? '';
	const display = displayProp ?? '';
	const colors = colorsProp ?? '';
	const sizes = sizesProp ?? '';
	const widths = widthsProp ?? '';
	const className = classNameProp ?? '';

	const clazz = ['btn', icon, quickTypes, display, colors, sizes, widths, className];

	if (newStyle) {
		clazz.push('new-style');
	}

	return (
		<Link
			to={to ?? ''}
			onClick={event => {
				if (onClick) {
					onClick(event);
				}
			}}
			className={classNames(clazz)}
			replace={replace}
			target={target}
			data-test-id={dataTestId}
		>
			{children}
		</Link>
	);
}
